import CryptoJS from "crypto-js";
import AsyncValidator from "async-validator";

/* 日期转化 */
export function formatDate(NewDtime) {
  let datetime = new Date(NewDtime);
  let year = datetime.getFullYear();
  let month = (datetime.getMonth() + 1).toString(); //js从0开始取
  let date = datetime.getDate().toString();
  let hour = datetime.getHours().toString();
  let minutes = datetime.getMinutes().toString();
  let second = datetime.getSeconds().toString();

  if (parseInt(month) < 10) {
    month = "0" + month;
  }
  if (parseInt(date) < 10) {
    date = "0" + date;
  }
  if (parseInt(hour) < 10) {
    hour = "0" + hour;
  }
  if (parseInt(minutes) < 10) {
    minutes = "0" + minutes;
  }
  if (parseInt(second) < 10) {
    second = "0" + second;
  }
  let time =
    year + "-" + month + "-" + date + " " + hour + ":" + minutes + ":" + second; //2009-06-12 17:18:05
  return time;
}
//将base64转换为blob
export function dataURLtoFile(dataURI, type) {
  let binary = atob(dataURI.split(",")[1]);
  let array = [];
  for (let i = 0; i < binary.length; i++) {
    array.push(binary.charCodeAt(i));
  }
  return new Blob([new Uint8Array(array)], { type: type });
}
// 格式化时间
export let formatDateReg = (d, fmt) => {
  let o = {
    "M+": d.getMonth() + 1, //月份
    "d+": d.getDate(), //日
    "h+": d.getHours(), //小时
    "m+": d.getMinutes(), //分
    "s+": d.getSeconds(), //秒
    "q+": Math.floor((d.getMonth() + 3) / 3), //季度
    S: d.getMilliseconds(), //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (d.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  for (let k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
  return fmt;
};
// 加密方法
export let encryptByDES = (message, key) => {
  console.log("key", key);
  let keyHex = CryptoJS.enc.Utf8.parse(key);
  let encrypted = CryptoJS.DES.encrypt(message, keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.toString();
};

//

export function deepCopyRef(obj) {
  let _obj = {}; //标记一个对象，使其永远不会转换为 proxy。返回对象本身。
  return Object.assign(_obj, obj);
}

function getCookie(name) {
  let reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  let arr = document.cookie.match(reg);
  if (arr) return unescape(arr[2]);
  else return null;
}

function DateStrKey() {
  let date = new Date();
  let y = date.getFullYear().toString();
  let m = (date.getMonth() + 1).toString();
  let d = date.getDate().toString();

  if (parseInt(m) < 10) {
    m = "0" + m;
  }
  if (parseInt(d) < 10) {
    d = "0" + d;
  }
  return `${y}-${m}-${d}`;
}

// 加密
export let encryptDES = (message, desKey) => {
  let key = desKey || `${getCookie("JSESSIONID")}-${DateStrKey()}`;
  console.log(key);
  let keyHex = CryptoJS.enc.Utf8.parse(key);
  if (message) {
    let encrypt = CryptoJS.DES.encrypt(message, keyHex, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });
    return encrypt.toString();
  } else {
    return "";
  }
};

// 解密
export let decryptDES = (ciphertext, desKey) => {
  let key = desKey || `${getCookie("JSESSIONID")}-${DateStrKey()}`;
  let keyHex = CryptoJS.enc.Utf8.parse(key);
  if (ciphertext) {
    let decrypted = CryptoJS.DES.decrypt(ciphertext, keyHex, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
  } else {
    return "";
  }
};

/**
 * @author 伟健 / 张
 * @name 根据key赋值
 * @param
 * @return original
 */
let hasOwnProperty = Object.prototype.hasOwnProperty;
export let setval = (original, _from) => {
  for (let key in original) {
    if (hasOwnProperty.call(_from, key)) {
      original[key] = _from[key];
    }
  }
  return original;
};

/**
 * @author 伟健 / 张
 * @name 清空对象值
 */
export let reset = (original, defaultVal) => {
  let len = Object.keys(original).length;
  for (let key in original) {
    if (len) {
      if (hasOwnProperty.call(defaultVal, key)) {
        original[key] = defaultVal[key];
      } else {
        original[key] = "";
      }
    } else {
      original[key] = "";
    }
  }
  return original;
};

export let throttle = function (action, delay) {
  let timeout = null;
  let lastRun = 0;
  return function () {
    if (timeout) {
      return;
    }
    let elapsed = Date.now() - lastRun;
    let context = this;
    let args = arguments;
    let runCallback = function () {
      lastRun = Date.now();
      timeout = false;
      action.apply(context, args);
    };
    if (elapsed >= delay) {
      runCallback();
    } else {
      timeout = setTimeout(runCallback, delay);
    }
  };
};

export let requiredVal = function () {
  let arg = [...arguments];
  return !arg.some((el) => {
    return el === "" || el === undefined || el === null || el.length == 0;
  });
};

export let dateFormat = (date, fmt) => {
  if (!date) return "";

  let o = {
    "M+": date.getMonth() + 1, // 月份
    "d+": date.getDate(), // 日
    "h+": date.getHours(), // 小时
    "m+": date.getMinutes(), // 分
    "s+": date.getSeconds(), // 秒
    "q+": Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds(), // 毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  for (let k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
    }
  }
  return fmt;
};
/**
 * @author 伟健 / 张
 * @name 合并对象
 */
export let extend = (vm, to, _from) => {
  for (let key in _from) {
    if (to[key] == undefined || to[key] == null || to[key] === "") {
      vm.$set(to, key, _from[key]);
    }
  }
  return to;
};

export let getPosition = (obj) => {
  var el = obj.getBoundingClientRect();
  var top =
    el.top -
    document.documentElement.clientTop +
    document.documentElement.scrollTop, //document.documentElement.clientTop 在IE67中始终为2，其他高级点的浏览器为0
    bottom = el.bottom,
    left =
      el.left -
      document.documentElement.clientLeft +
      document.documentElement.scrollLeft, //document.documentElement.clientLeft 在IE67中始终为2，其他高级点的浏览器为0
    right = el.right,
    width = el.width || right - left, //IE67不存在width 使用right - left获得
    height = el.height || bottom - top;

  return {
    y: top,
    right: right,
    bottom: bottom,
    x: left,
    width: width,
    height: height,
  };
};

// 获取滚动条距离
export let getScroll = (direction, el) => {
  if (el) {
    return el[direction] || el[direction];
  }
  return document.body[direction] || document.documentElement[direction];
};

export let classNameToArray = (cls = "") =>
  cls.split(" ").filter((item) => !!item.trim());

export let addClass = (el, cls) => {
  if (!el || !cls.trim()) return;
  el.classList.add(...classNameToArray(cls));
};

export let removeClass = (el, cls) => {
  if (!el || !cls.trim()) return;
  el.classList.remove(...classNameToArray(cls));
};

export let remove = (arr, item) => {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1);
    }
  }
};

export let browserType = () => {
  return window.navigator.userAgent;
};
export let isIE = function () {
  if (!!window.ActiveXObject || "ActiveXObject" in window) return true;
  else return false;
};

export let openUrl = function (url) {
  if (!url) return;
  let reg = /#[\/\w]+\?/;

  if (url.match(reg)) {
    if (
      url.match(reg)[0] == window.location.href.match(reg) &&
      window.location.href.match(reg)[0]
    ) {
      return;
    }
  }

  if (isIE()) {
    try {
      if (url.indexOf("#") > -1) {
        let _url = url.split("#")[1];
        let path = _url.split("?")[0];
        this.$router.push({ path, query: rulTojson(_url) });
      }
    } catch (e) {
      console.log(e);
      location.assign(encodeURIComponent(url));
      window.location.href = url;
    }
  } else {
    // window.location.href = url;
    window.fixOpen(url, "_self");
  }
};

export let openUrlByClick = (url, target = "_blank") => {
  // 1. 创建 <a> 标签
  const link = document.createElement("a");

  // 2. 设置属性
  link.href = url;
  link.target = target; // 可选：_blank（新标签页）或 _self（当前页）
  link.rel = "noopener noreferrer"; // 安全建议

  // 3. 隐藏元素（避免影响页面布局）
  link.style.display = "none";
  // 4. 将元素添加到页面
  document.body.appendChild(link);
  // 5. 模拟点击
  link.click();
  // 6. 移除元素（清理DOM）
  document.body.removeChild(link);
};

export let isString = (val) => typeof val === "string";
/**
 * @author 伟健 / 张
 * @name 检查是否为空
 * @param
 * @return
 */
export let required = () => {
  let arg = [...arguments];
  return !arg.some((el) => {
    return el == "" || el == undefined || el == null;
  });
};
/**
 * @author 伟健 / 张
 * @name  传入对象，键，返回对应值
 * @param obj keys
 * @return obj[]
 */
export let keysRetrievalObj = (obj, keys) => {
  if (obj && keys) {
    return [];
  }
};

/* 
递归对象,并获取对象指定 键的值
*/

export let recursiveSearch = (obj, key, key1) => {
  let res = [];
  function main(obj, key, key1) {
    if (obj[key1]) {
      res.push(obj[key1]);
    }
    for (let i = 0; i < obj.length; i++) {
      if (obj[i][key]) {
        main(obj[i][key], key, key1);
      } else {
        main(obj[i], key, key1);
      }
    }
  }
  main(obj, key, key1);
  return res;
};

export let base64toFile = (dataurl, filename = "file") => {
  let arr = dataurl.split(",");
  let mime = arr[0].match(/:(.*?);/)[1];
  let suffix = mime.split("/")[1];
  let bstr = atob(arr[1]);
  let n = bstr.length;
  let u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  let File = window.File;
  try {
    new File([], "");
  } catch (e) {
    console.log(e);
    File = class File extends Blob {
      constructor(chunks, filename, opts = {}) {
        super(chunks, opts);
        this.lastModifiedDate = new Date();
        this.lastModified = +this.lastModifiedDate;
        this.name = filename;
      }
    };
  }
  return new File([u8arr], `${filename}.${suffix}`, {
    type: mime,
  });
};
/**
 * @author 伟健 / 张
 * @name 检查 formData 参数
 */
export let checkFormData = (formData, rules, callback) => {
  if (!rules || !formData) return;

  let valid = true;
  let validateMessage = "";
  Object.keys(formData).forEach((key) => {
    let descriptor = {};
    if (!rules[key] || !valid) return;
    descriptor[key] = rules[key];
    let validator = new AsyncValidator(descriptor);
    let model = {};
    model[key] = formData[key];
    // console.log(model[key]);
    validator.validate(model, { firstFields: true }, (errors) => {
      let validateState = !errors ? "success" : "error";
      validateMessage = errors ? errors[0].message : "";
      if (validateState == "error") {
        valid = false;
      }
    });
  });
  callback(valid, validateMessage);
};
export let copyText = (value, fn) => {
  if (!value) {
    return;
  }
  var textArea = document.createElement("textarea");
  textArea.style.background = "transparent";
  textArea.value = value;
  document.body.appendChild(textArea);
  textArea.select();
  try {
    document.execCommand("copy");
    fn && fn();
    // this.$message.success({
    //   message: '复制成功',
    // });
  } catch (err) {
    console.log(err);
    console.log("Oops, unable to copy");
  }
  document.body.removeChild(textArea);
};

export let setCopyright = function (value) {
  if (!value || !Object.keys(value).length) {
    return;
  }
  this.guaranteeChannelHtmlPage = value;
  document.title = value.htmlTitle || "保函申请";
  var favicon = document.querySelector('link[rel="icon"]');
  if (favicon !== null && value.htmlIcon) {
    favicon.href = value.htmlIcon;
  } else {
    favicon = document.createElement("link");
    favicon.rel = "shortcut icon";
    if (value.htmlIcon) favicon.href = value.htmlIcon;
    document.head.appendChild(favicon);
  }
  Mirror.emit(`setCopyright`, value);
};

export let rulTojson = function (url) {
  let obj = {};
  let index = url.indexOf("?");
  if (index > -1) {
    let strs = url.split("?")[1].split("&");
    for (let i = 0; i < strs.length; i++) {
      obj[strs[i].split("=")[0]] = strs[i].split("=")[1] || "";
    }
  }
  return obj;
};

// 获取地址栏参数
export let getUrlQuery = function (url) {
  if (!url) {
    url = window.location.href;
  }
  if (!url.split("?")[1]) {
    return false;
  }
  let urlStr = url.split("?")[1];
  let queryStrList = urlStr.split("&");
  let queryObj = {};
  for (let i = 0; i < queryStrList.length; i++) {
    let queryStr = queryStrList[i];
    let queryStrArr = queryStr.split("=");
    queryObj[queryStrArr[0]] = queryStrArr[1];
  }
  console.log(queryObj);
  return queryObj;
};
export let getSignTaction = function () {
  // let signApis = {

  //   GongcTenderbidInsure: "customer/seal/", //工程投标保函
  //   GongcTenderbid: "customer/seal/", //工程投标保函
  //   GongcSafeLiability: "customer/seal/", // 安责险
  //   PurchaseTenderbid: "customer/seal/", //政采投标保函
  //   CourtLowsuit: "customer/seal/", //法院诉讼
  //   PurchaseContract: "customer/seal/", //政采合同履约
  //   GongcContract: "customer/seal/", //工程合同履约
  //   GongcNongmg: "customer/seal/", ///农民工工资保函
  //   GongcQuality: "customer/seal/", //工程质量保函
  //   CustomsInsure: "customer/seal/external/",//海关投保
  //   CustomsCancel: 'customer/seal/external/',//海关退保
  // }
  // let newProject = [
  //   "GongcContractFulfillInsure",
  //   "CustomsInsure",
  //   "CustomsCancel",
  //   "GongcOwnerAdvancePaymentInsure",
  //   "GongcOwnerAdvancePaymentCancel",
  //   "PurchaseOwnerAdvancePaymentInsure",
  //   "PurchaseOwnerAdvancePaymentCancel",
  //   "OwnerEnsurePaymentInsure",
  //   "OwnerEnsurePaymentCancel",
  //   "AuctionInsure", //竞买
  //   "AuctionCancel", //竞买
  // ];
  // let query = getUrlQuery();

  // if (query && query.taction && newProject.indexOf(query.taction) > -1) {
  //   return "customer/seal/external/";
  // } else {
  //   return "customer/seal/";
  // }
  let oldProject = [
    "GongcTenderbidInsure",
    "GongcTenderbidCancel",
    "PurchaseTenderbidInsure",
    "PurchaseTenderbidCancel",
    "GongcSafeLiabilityInsure",
  ];
  let query = getUrlQuery();
  if (query && query.taction && oldProject.indexOf(query.taction) > -1) {
    return "customer/seal/";
  } else {
    return "customer/seal/external/";
  }
};

export function isArray(obj) {
  if (!obj || obj == null) return false;
  // 优先使用现代浏览器API（性能更好）
  if (typeof Array.isArray === "function") {
    return Array.isArray(obj);
  }
  // IE兼容方案
  return Object.prototype.toString.call(obj) === "[object Array]";
}

export function isObject(obj) {
  // 过滤null（因为typeof null === 'object'）
  return (
    obj !== null && Object.prototype.toString.call(obj) === "[object Object]"
  );
}

export function extractBirthdayFromIdCard(idCard) {
  // 基本验证：必须是字符串或数字
  if (typeof idCard !== "string" && typeof idCard !== "number") {
    return null;
  }

  // 转换为字符串并去除前后空格
  idCard = idCard.toString().trim();

  // 验证身份证号码长度（15位或18位）
  if (idCard.length !== 15 && idCard.length !== 18) {
    return null;
  }

  // 提取出生日期部分
  let birthDateStr;
  if (idCard.length === 15) {
    // 15位身份证：7-12位是出生日期（YYMMDD）
    birthDateStr = "19" + idCard.substring(6, 12);
  } else {
    // 18位身份证：7-14位是出生日期（YYYYMMDD）
    birthDateStr = idCard.substring(6, 14);
  }

  // 验证提取的日期字符串是否全是数字
  if (!/^\d+$/.test(birthDateStr)) {
    return null;
  }

  // 解析年月日
  const year = birthDateStr.substring(0, 4);
  const month = birthDateStr.substring(4, 6);
  const day = birthDateStr.substring(6, 8);

  // 简单验证日期有效性（不进行复杂的日期验证，如闰年等）
  const monthInt = parseInt(month, 10);
  const dayInt = parseInt(day, 10);

  if (monthInt < 1 || monthInt > 12 || dayInt < 1 || dayInt > 31) {
    return null;
  }

  // 返回格式化后的日期字符串
  return `${year}年${month}月${day}日`;
}

export let getCityAssetsFile = (path) => {
  let city = window.config.city || "huang-shi";
  return new URL(`../img/city/${city}/${path}`, import.meta.url).href;
};

export let getAssetsFile = (path) => {
  if (path.indexOf("public/") > -1) {
    path = path.replace("public/", "");
    return new URL(`../img/public/${path}`, import.meta.url).href;
  }
  if (path.indexOf("bill/") > -1) {
    path = path.replace("bill/", "");
    return new URL(`../img/bill/${path}`, import.meta.url).href;
  }
  if (path.indexOf("external/") > -1) {
    path = path.replace("external/", "");
    return new URL(`../img/external/${path}`, import.meta.url).href;
  }
  if (path.indexOf("rate/") > -1) {
    path = path.replace("rate/", "");
    return new URL(`../img/rate/${path}`, import.meta.url).href;
  }
  if (path.indexOf("loan/") > -1) {
    path = path.replace("loan/", "");
    return new URL(`../img/loan/${path}`, import.meta.url).href;
  }
  if (path.indexOf("index/") > -1) {
    path = path.replace("index/", "");
    return new URL(`../img/index/${path}`, import.meta.url).href;
  }
  // 其他情况，默认返回img目录下的文件
  if (
    path.indexOf("public/") <= -1 &&
    path.indexOf("bill/") <= -1 &&
    path.indexOf("external/") <= -1 &&
    path.indexOf("rate/") <= -1 &&
    path.indexOf("loan/") <= -1 &&
    path.indexOf("index/") <= -1
  ) {
    return new URL(`../img/${path}`, import.meta.url).href;
  }
};


export let watchPayment = (handelerefreshResult, path) => {
  if (!handelerefreshResult || !path || !window.location.hash.includes(path)) return

  let timer = setInterval(() => {
    handelerefreshResult(false);
  }, 20000);
  window.addEventListener('focus', () => {
    if (window.location.hash.includes(path)) {
      handelerefreshResult(false);
      clearInterval(timer);
      timer = setInterval(() => {
        handelerefreshResult(false);
      }, 20000);
    }
  });

  // 窗口失去焦点
  window.addEventListener('blur', () => {
    // clearInterval(timer);
    // timer = null;
  });
  return timer;
}